import React from "react";
import { Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store, history } from "./Redux/store";
import MainAppContainer from "./MainAppContainer";
import UserRegistration from "./Components/UserRegistration";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "./App.css";

function App() { 
    return (
      <div className="App">
        <ReactNotification />
        <Provider store={store}>
          <Router history={history}>
            <Route path="/" component={MainAppContainer} />
            <Route path="/try/signup/" component={UserRegistration} />
          </Router>
        </Provider>
      </div>
    );
}

export default App;